import { Loadable } from '@/components/Loadable';
import { breakpoints } from '@/utils/breakpoints';
import { Dialog, Icons, Sheet } from '@fleet/webshop-ui';
import { type FC, type ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';

interface ResponsiveDialogProps {
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
  loading?: boolean;
  trigger?: ReactNode;
  title: ReactNode;
  content: ReactNode;
  footer?: ReactNode;
}

const ResponsiveDialog: FC<ResponsiveDialogProps> = ({
  open,
  onOpenChange,
  loading = false,
  trigger,
  title,
  content,
  footer,
}) => {
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  if (isLaptopOrBigger) {
    return (
      <Dialog
        isOpen={open}
        onOpenChange={onOpenChange}
        trigger={trigger}
        headerTitle={title}
        footer={footer}
        className={{
          root: 'w-[650px] max-w-none',
          content: 'p-0',
        }}
        data-testid="responsive-dialog"
      >
        <Loadable
          loading={loading}
          persistent
          className={{ persistent: 'min-h-[500px]' }}
        >
          {content}
        </Loadable>
      </Dialog>
    );
  }

  return (
    <Sheet
      isOpen={open}
      onOpenChange={onOpenChange}
      trigger={trigger}
      headerTitle={title}
      closeIcon={<Icons.arrowLeft height={24} width={24} />}
      footer={footer}
      className={{ root: 'min-w-full', content: 'p-0' }}
      data-testid="responsive-dialog-sheet"
    >
      <Loadable
        loading={loading}
        persistent
        className={{ persistent: 'flex-1 overflow-auto' }}
      >
        {content}
      </Loadable>
    </Sheet>
  );
};

export default ResponsiveDialog;
